import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveMedia } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { Crown } from "@phosphor-icons/react";

const LABELS = { "Open": "Open", "35 Over": "35+", "45 Over": "45+" };

export function SeasonChampionBanner() {
  const { settings } = useSettings();
  const [champs, setChamps] = useState([]);

  useEffect(() => {
    api.get("/playoffs").then((r) => {
      const brackets = r.data?.brackets || {};
      const out = [];
      Object.entries(brackets).forEach(([div, b]) => {
        if (b && b.champion_team_id) {
          const t = (b.teams || {})[b.champion_team_id];
          if (t) out.push({ division: div, label: LABELS[div] || div, name: t.name, logo_url: t.logo_url, primary_color: t.primary_color });
        }
      });
      setChamps(out);
    }).catch(() => {});
  }, []);

  if (champs.length === 0) return null;

  return (
    <section className="relative border-y border-[#FF5722]/30 bg-gradient-to-r from-[#FF5722]/15 via-[#0A0A0A] to-[#0A0A0A]" data-testid="season-champion-banner">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3 mb-8">
          <Crown size={26} weight="fill" className="text-[#FF5722]" />
          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#FF5722] font-semibold">{settings?.season_title || ""} Champions</p>
            <h2 className="font-display text-3xl sm:text-4xl uppercase leading-none">Reigning Champions</h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {champs.map((c) => (
            <Link
              key={c.division}
              to={`/playoffs?division=${encodeURIComponent(c.division)}`}
              data-testid={`champion-card-${c.division.replace(/\s+/g, "-").toLowerCase()}`}
              className="group flex items-center gap-4 border border-[#FF5722]/40 bg-[#121212] p-5 hover:border-[#FF5722] transition-colors duration-200"
            >
              {c.logo_url
                ? <img src={resolveMedia(c.logo_url)} alt={c.name} className="w-16 h-16 object-contain shrink-0" />
                : <span className="w-16 h-16 flex items-center justify-center font-display text-3xl shrink-0" style={{ backgroundColor: c.primary_color || "#FF5722", color: "#000" }}>{c.name.charAt(0)}</span>}
              <div className="min-w-0">
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#FF5722] font-bold">{c.label} Champion</p>
                <p className="font-display text-2xl sm:text-3xl uppercase leading-tight truncate group-hover:text-[#FF5722] transition-colors">{c.name}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
